// /src/api/config/apiConfig.js
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://backend.shelozon.com/api";
export const API_KEY = "your-api-key";

export const Bucket =
  "https://eu2.contabostorage.com/4e5c5b4868a5450aa89f1422b00b2d85:shelozon/";

/**
 * Resolves an image key to its full S3 URL or direct URL
 */
export const getImageUrl = (key) => {
  if (!key) return "";
  if (key.startsWith("http://") || key.startsWith("https://") || key.startsWith("blob:") || key.startsWith("data:")) {
    return key;
  }
  const cleanKey = key.startsWith("/") ? key.substring(1) : key;
  return `${Bucket}${cleanKey}`;
};

/**
 * Derives the WebSocket/Socket.IO base URL
 * @param {string} namespace Optional namespace e.g. "communication"
 */
export const getSocketUrl = (namespace = "") => {
  if (process.env.REACT_APP_SOCKET_URL) {
    const base = process.env.REACT_APP_SOCKET_URL.replace(/\/+$/, "");
    return namespace ? `${base}/${namespace.replace(/^\/+/, "")}` : base;
  }
  // Strip trailing /api or /api/
  const base = API_BASE_URL.replace(/\/api\/?$/, "");
  return namespace ? `${base}/${namespace.replace(/^\/+/, "")}` : base;
};
